import { ChangeDetectionStrategy, Component, DestroyRef, OnInit, computed, input, signal } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabelModule } from 'primeng/floatlabel';
import { DropdownModule } from 'primeng/dropdown';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputMaskModule } from 'primeng/inputmask';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { RadioButtonModule } from 'primeng/radiobutton';
import { CalendarModule } from 'primeng/calendar';
import { CheckboxModule } from 'primeng/checkbox';
import { AutoCompleteCompleteEvent, AutoCompleteModule } from 'primeng/autocomplete';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { InputSwitchModule } from 'primeng/inputswitch';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { EditComponent } from '../../../core/components/edit/edit.component';
import { DropdownModel } from '../../../core/models/dropdown.model';

import { noteForm } from '../forms/note.form';
import { NoteService } from '../../../services/note.service';
import { CustomerService } from './../../../services/customer.service';
import { QuoteService } from './../../../services/quote.service';
import { Quote } from '../../../core/models/quote.model';
import { ViewComponent } from '../../../core';
import { ValidationFeedbackComponent } from '../../../shared/components/validation-feedback/validation-feedback.component';
import { categoryDropdown } from '../../../shared/consts/category-dropdown';
import { subCategoryDropdown } from '../../../shared/consts/sub-category-dropdown';
import { ContentHeaderEditComponent } from '../../../shared/components/content-header-edit/content-header-edit.component';
import { SubCategoryDropdownModel } from '../../../core';

@Component({
  selector: 'app-note-edit',
  standalone: true,
  imports: [
    CommonModule,
    ButtonModule,
    ReactiveFormsModule,
    InputTextModule,
    FloatLabelModule,
    DropdownModule,
    FormsModule,
    InputNumberModule,
    InputMaskModule,
    InputTextareaModule,
    ToastModule,
    RadioButtonModule,
    CheckboxModule,
    CalendarModule,
    AutoCompleteModule,
    MultiSelectModule,
    ProgressSpinnerModule,
    ViewComponent,
    InputSwitchModule,
    ValidationFeedbackComponent,
    ContentHeaderEditComponent,
  ],
  providers: [],
  templateUrl: './note-edit.component.html',
  styleUrls: ['./note-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NoteEditComponent extends EditComponent implements OnInit {
  categoryControl = signal(this.formGroup.controls['category']);
  subCategoryControl = signal(this.formGroup.controls['subCategory']);
  entityTypeControl = signal(this.formGroup.controls['entityType']);
  entityIDControl = signal(this.formGroup.controls['entityID']);
  contentControl = signal(this.formGroup.controls['content']);

  constructor(public override route: ActivatedRoute, public override router: Router, public override messageService: MessageService, public noteService: NoteService, private _customerService: CustomerService, private _quoteService: QuoteService) {
    super(noteService, route, router, noteForm(), messageService);
  }

  ngOnInit() {}

  override id = input<string>();
  title = computed(() => `Note - ${this.id() ? 'Update' : 'New'}`);

  public filteredCustomers = signal<DropdownModel[]>([]);
  public filteredQuotes = signal<DropdownModel[]>([]);

  public categorys: DropdownModel[] = categoryDropdown();
  public subCategories: SubCategoryDropdownModel[] = subCategoryDropdown();
  subCategoriesCopy: SubCategoryDropdownModel[] = this.subCategories;

  filterCustomer(event: AutoCompleteCompleteEvent) {
    return this.filterEntities(this._customerService, (result) => this.filteredCustomers.set(result), event);
  }

  filterQuote(event: AutoCompleteCompleteEvent) {
    return this.filterEntities(this._quoteService, (result) => this.filteredQuotes.set(result), event);
  }

  public override async loadSuggestions(values: Quote) {
    await this.filterCustomer(<AutoCompleteCompleteEvent>{
      query: values.customerID,
    });
    await this.filterQuote(<AutoCompleteCompleteEvent>{
      query: values.quoteID,
    });
  }

  selectSubCategories(category: any) {
    this.subCategories = this.subCategoriesCopy;
    const filteredRecords = this.subCategories.filter((s) => s.filterField === category);
    this.subCategories = filteredRecords;
  }
}



